<div
  class="friend d-flex align-items-center"
  (click)="publicProfile()"
  [class.isSelf]="isSelf">
  <div class="col-auto avatar">
    <slotcom-avatar
      [userId]="friend.id"
      [isFriend]="friend.friendship === 1"></slotcom-avatar>
  </div>

  <div class="col user">
    <slotcom-h2 [text]="friend.nickName"></slotcom-h2>
  </div>

  @if (friend.friendship === 2) {
    <div class="col-auto justify-content-end d-inline-flex">
      <slotcom-button
        (safeClick)="rejectFriendRequest()"
        audioType="functionality"
        class="c-button--pink small">
        <span class="icons-sprite tiny cross"></span>
      </slotcom-button>

      <slotcom-button
        (safeClick)="acceptFriendRequest()"
        audioType="functionality"
        class="c-button--pink small">
        <span class="icons-sprite tiny tick"></span>
      </slotcom-button>
    </div>
  }
</div>
@if (!isSelf) {
  <slotcom-divider></slotcom-divider>
}
